<template>
  <div v-bind:class="'spinner ' + colorClass">
  </div>
</template>

<script>
export default {
  name: 'loader',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  props: ['colorClass']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spinner {
  width: 40px;
  height: 40px;
  margin: 100px auto;
  background-color: transparent;
  border: 3px solid #000;

  border-radius: 100%;  
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}
.spinner.black {
  border: 2px solid #000;
}
.spinner.white {
  border: 2px solid #fff;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(2) }
  100% {
    -webkit-transform: scale(1.2);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Loader.vue?510226e8